import ListIcon from "../../../icons/ListIcon";
import KodelisteNavnOgNr from "../../../accordion/admin/kodelister/KodelisteNavnOgNr";
import { adminKodelisteSanktionstypeForm } from "../../../../config/form/admin/adminKodelisteSanktionstyperFormConfig";
import { adminKodelisteEfteruddannelsestypeForm } from "../../../../config/form/admin/adminKodelisteEfteruddannelsestyperFormConfig";
import KodelisteSanktionstyper from "../../../accordion/admin/kodelister/KodelisteSanktionstyper";
import KodelisteEfteruddannelsestyper from "../../../accordion/admin/kodelister/KodelisteEfteruddannelsestyper";
import { useContext } from "react";
import { UserQueryContext } from "../../../../context/UserContext";
import Hoteller from "../../../accordion/admin/kodelister/Hoteller";
import Interesser from "../../../accordion/admin/kodelister/Interesser";
import UdenlandskAdvokatsamfund from "../../../accordion/admin/kodelister/UdenlandskAdvokatsamfund";
import Udvalg from "../../../accordion/admin/kodelister/Udvalg";

export default function Kodelister() {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "AdminWrite");
  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <ListIcon width={16} />
        </span>
        <span>Kodelister</span>
      </h3>
      <ul className="list-group list-group-flush mt-2 border-top border-bottom">
        <li className="list-group-item p-0">
          <KodelisteNavnOgNr
            kodelisteQueryType="disciplinaerstatustype"
            title="Disciplinaerstatustyper"
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <KodelisteEfteruddannelsestyper
            formConfig={adminKodelisteEfteruddannelsestypeForm}
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <Hoteller canWrite={canWrite} />
        </li>
        <li className="list-group-item p-0">
          <Interesser canWrite={canWrite} />
        </li>
        <li className="list-group-item p-0">
          <KodelisteNavnOgNr
            kodelisteQueryType="kursustype"
            title="Kursustyper"
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <KodelisteNavnOgNr
            kodelisteQueryType="persontype"
            title="Persontyper"
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <KodelisteSanktionstyper
            formConfig={adminKodelisteSanktionstypeForm}
            title="Sanktionstyper"
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <KodelisteNavnOgNr
            kodelisteQueryType="selskabstype"
            title="Selskabstyper"
            canWrite={false}
          />
        </li>
        <li className="list-group-item p-0">
          <UdenlandskAdvokatsamfund canWrite={canWrite} />
        </li>
        <li className="list-group-item p-0">
          <Udvalg canWrite={canWrite} />
        </li>
      </ul>
    </div>
  );
}
